import type { ComponentTheme } from '../types/component-theme';

import { SidebarNavIconVariants } from './constants/sidebar-nav-icon';

export default {
    slots: {
        root: 'flex shrink-0 items-center justify-center',
        icon: ''
    },
    variants: {
        variant: {
            [SidebarNavIconVariants.Base]: {
                root:
                    'h-7.5 w-7.5 rounded-[0.5rem] bg-[rgba(71,85,105,0.06)] text-(--accent-solid) ' +
                    'shadow-[inset_0.063rem_0.063rem_0.125rem_rgba(5,5,5,0.07),inset_-0.063rem_-0.063rem_0.094rem_rgba(255,255,255,0.35)] ' +
                    'group-hover:text-(--text-strong) group-hover:bg-(--slate-strong-alpha-10)',
                icon: 'text-[0.9375rem]'
            },
            [SidebarNavIconVariants.Sub]: {
                root:
                    'h-6.5 w-6.5 rounded-[0.438rem] bg-(--slate-alpha-06) text-(--text-light) ' +
                    'shadow-[inset_0.063rem_0.063rem_0.094rem_rgba(5,5,5,0.06),inset_-0.063rem_-0.063rem_0.063rem_rgba(255,255,255,0.3)] ' +
                    'group-hover:text-(--accent-solid) group-hover:bg-(--slate-strong-alpha-10)',
                icon: 'text-[0.875rem]'
            }
        },
        active: {
            true: {
                root: 'bg-(--slate-strong-alpha-18) text-(--text-strong)'
            }
        }
    },
    compoundVariants: [
        {
            variant: SidebarNavIconVariants.Base,
            active: true,
            class: {
                root: 'shadow-[0.125rem_0.125rem_0.25rem_rgba(163,177,198,0.45),-0.125rem_-0.125rem_0.25rem_var(--glass-border-top)]'
            }
        },
        {
            variant: SidebarNavIconVariants.Sub,
            active: true,
            class: {
                root: 'shadow-[0.094rem_0.094rem_0.188rem_rgba(163,177,198,0.4),-0.063rem_-0.063rem_0.188rem_rgba(255,255,255,0.75)]'
            }
        }
    ]
} satisfies ComponentTheme;
